import { render, staticRenderFns } from "./fundNotice.vue?vue&type=template&id=20c3d667"
import script from "./fundNotice.vue?vue&type=script&lang=js"
export * from "./fundNotice.vue?vue&type=script&lang=js"
import style0 from "./fundNotice.vue?vue&type=style&index=0&id=20c3d667&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports